import React from 'react';

function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmStyle = 'primary',
  onConfirm,
  onCancel,
  loading = false,
  children
}) {
  if (!isOpen) return null;

  // Brand colors matching Deep Red & Cream theme
  const getButtonClass = () => {
    switch (confirmStyle) {
      case 'danger':
        return { background: '#C62828', color: 'white' }; // Error red
      case 'success':
        return { background: '#4A7C59', color: 'white' }; // Sage green
      default:
        return { background: '#8B2635', color: 'white' }; // Primary burgundy
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: '1rem'
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '12px',
          maxWidth: '450px',
          width: '100%',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '1.25rem 1.5rem',
          borderBottom: '1px solid #E8E4E0',
          background: confirmStyle === 'danger' ? '#FEE9E9' : '#FAF8F5'
        }}>
          <h3 style={{
            margin: 0,
            fontSize: '1.125rem',
            fontWeight: '600',
            color: confirmStyle === 'danger' ? '#C62828' : '#2C2C2C'
          }}>
            {title}
          </h3>
        </div>

        {/* Body */}
        <div style={{ padding: '1.5rem' }}>
          {message && (
            <p style={{ margin: 0, color: '#6B6B6B', lineHeight: '1.6' }}>
              {message}
            </p>
          )}
          {children}
        </div>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.5rem',
          borderTop: '1px solid #E8E4E0',
          background: '#FAF8F5',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0.75rem',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: '1px solid #D4CBC3',
              background: 'white',
              color: '#2C2C2C',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1,
              minHeight: '44px',
              minWidth: '80px'
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '500',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              minHeight: '44px',
              minWidth: '80px',
              ...getButtonClass()
            }}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
